// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__zRLNm","savePackageButton":"ClientWallet_savePackageButton__1O0Ke"};